import API from "../../services/api";

/*
|--------------------------------------------------------------------------
| Roles
|--------------------------------------------------------------------------
*/

export const getRoles = () =>
    API.get("/admin/roles");

export const getRoleById = (id) =>
    API.get(`/admin/roles/${id}`);

export const createRole = (data) =>
    API.post("/admin/roles", data);

export const updateRole = (id, data) =>
    API.put(`/admin/roles/${id}`, data);

export const updateRoleStatus = (id, status) =>
    API.patch(`/admin/roles/${id}/status`, {
        status,
    });

export const deleteRole = (id) =>
    API.delete(`/admin/roles/${id}`);